import { createContext } from 'react'

export const SegmentedContext = createContext()
